"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdateVehicleCustomTagsMutation = exports.useGetVehicleCustomTagsQuery = exports.useGetVehicleInfoForVinQuery = exports.useGetVehicleListPageQuery = exports.useGetVehicleListQuery = exports.useLazyGetVehicleListQuery = exports.vehicleApi = exports.vehiclesWithCustomTagsEtl = exports.useHostStore = exports.useHostSelector = exports.useHostDispatch = exports.sharedStore = exports.sharedContext = exports.VEHICLE_LIST_CUSTOM_TAGS = exports.VEHICLE_LIST_TAG = exports.VEHICLE_TAG = void 0;
var react_1 = __importDefault(require("react"));
var react_2 = require("@reduxjs/toolkit/query/react");
var react_redux_1 = require("react-redux");
var browserStorage_1 = require("@dtna/dvs-core-dcp-client-utils/lib/utils/browserStorage");
var proxyApi_1 = require("../constants/proxyApi");
var common_1 = require("../utils/common");
exports.VEHICLE_TAG = 'VEHICLE_TAG';
exports.VEHICLE_LIST_TAG = 'VEHICLE_LIST_TAG';
exports.VEHICLE_LIST_CUSTOM_TAGS = 'VEHICLE_LIST_CUSTOM_TAGS';
if (!window.sharedContext) {
    window.sharedContext = react_1.default.createContext({});
    window.sharedContext.displayName = 'sharedContext';
}
exports.sharedContext = window.sharedContext, exports.sharedStore = window.sharedStore;
exports.useHostDispatch = (0, react_redux_1.createDispatchHook)(exports.sharedContext);
exports.useHostSelector = (0, react_redux_1.createSelectorHook)(exports.sharedContext);
var useHostStore = function () { return exports.sharedStore; };
exports.useHostStore = useHostStore;
var customCreateApi = (0, react_2.buildCreateApi)((0, react_2.coreModule)(), (0, react_2.reactHooksModule)({ useDispatch: exports.useHostDispatch, useSelector: exports.useHostSelector, useStore: exports.useHostStore }));
var vehiclesWithCustomTagsEtl = function (vehicles) { return vehicles.map(function (vehicle) { return ({
    customTags: vehicle.customTags,
    serial: vehicle.serial,
    unitId: vehicle.unitId || '',
    vin: vehicle.vin,
}); }); };
exports.vehiclesWithCustomTagsEtl = vehiclesWithCustomTagsEtl;
exports.vehicleApi = customCreateApi({
    reducerPath: 'vehicleApi',
    tagTypes: [exports.VEHICLE_TAG, exports.VEHICLE_LIST_TAG, exports.VEHICLE_LIST_CUSTOM_TAGS],
    baseQuery: (0, react_2.fetchBaseQuery)({
        baseUrl: proxyApi_1.BASE_URL,
        prepareHeaders: function (headers) { return __awaiter(void 0, void 0, void 0, function () {
            var token;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, browserStorage_1.getTokenResponse)()];
                    case 1:
                        token = _a.sent();
                        headers.set('Authorization', "Bearer ".concat(token.bearerToken));
                        return [2 /*return*/, headers];
                }
            });
        }); },
    }),
    endpoints: function (build) { return ({
        getVehicleList: build.query({
            query: function () { return proxyApi_1.PROXY_API.GET.VEHICLE.LIST.replace(':tan', (0, common_1.getTan)()); },
            providesTags: [exports.VEHICLE_LIST_TAG],
        }),
        getVehicleInfoForVin: build.query({
            query: function (vin) { return ({
                url: proxyApi_1.PROXY_API.GET.VEHICLE.INFO.replace(':tan', (0, common_1.getTan)()).replace(':vin', vin),
            }); },
            providesTags: [exports.VEHICLE_TAG],
        }),
        getVehicleListPage: build.query({
            queryFn: function (arg, _queryApi, _extraOptions, fetchWithBQ) {
                return __awaiter(this, void 0, void 0, function () {
                    var _a, pageSize, response, e_1;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                _a = (arg || {}).pageSize, pageSize = _a === void 0 ? proxyApi_1.VEHICLES_LIST.RECORDS_PER_REQUEST : _a;
                                _b.label = 1;
                            case 1:
                                _b.trys.push([1, 3, , 4]);
                                return [4 /*yield*/, fetchWithBQ({
                                        url: proxyApi_1.PROXY_API.GET.VEHICLE.LIST_PAGE_TAN.replace(/:tan/, (0, common_1.getTan)()),
                                        method: 'GET',
                                        params: {
                                            pageSize: pageSize,
                                        },
                                    })];
                            case 2:
                                response = _b.sent();
                                return [2 /*return*/, { data: response.data.vehicles }];
                            case 3:
                                e_1 = _b.sent();
                                return [2 /*return*/, { error: e_1 }];
                            case 4: return [2 /*return*/];
                        }
                    });
                });
            },
        }),
        getVehicleCustomTags: build.query({
            query: function () { return proxyApi_1.PROXY_API.GET.VEHICLE.VEHICLE_BRIEFINFO.replace(/:tan/, (0, common_1.getTan)()); },
            transformResponse: function (response) { return (0, exports.vehiclesWithCustomTagsEtl)(response); },
            providesTags: [exports.VEHICLE_LIST_CUSTOM_TAGS],
        }),
        updateVehicleCustomTags: build.mutation({
            query: function (payload) { return ({
                url: proxyApi_1.PROXY_API.POST.VEHICLE.TAGS_TAN.replace(':tan', (0, common_1.getTan)()),
                method: 'POST',
                body: [payload],
            }); },
            invalidatesTags: [exports.VEHICLE_LIST_CUSTOM_TAGS, exports.VEHICLE_TAG],
        }),
    }); },
});
exports.useLazyGetVehicleListQuery = exports.vehicleApi.useLazyGetVehicleListQuery, exports.useGetVehicleListQuery = exports.vehicleApi.useGetVehicleListQuery, exports.useGetVehicleListPageQuery = exports.vehicleApi.useGetVehicleListPageQuery, exports.useGetVehicleInfoForVinQuery = exports.vehicleApi.useGetVehicleInfoForVinQuery, exports.useGetVehicleCustomTagsQuery = exports.vehicleApi.useGetVehicleCustomTagsQuery, exports.useUpdateVehicleCustomTagsMutation = exports.vehicleApi.useUpdateVehicleCustomTagsMutation;
